import styled from 'styled-components';
import { FakeButton } from '@atlassian/help-center-common-component/fake-button';
import * as fonts from 'view/styles/fonts';
import * as grid from 'view/styles/grid';
import { token } from '@atlaskit/tokens';
import { colors } from '@atlaskit/theme';

export const minDescriptionHeight = grid.multiple(4.5).unitless;

export const HelpText = styled.div`
    ${fonts.xsmall};
    margin-top: ${token('space.050', '4px')};
    color: ${token('color.text.subtlest', colors.N200)};
`;

export const ButtonText = styled.span`
    ${fonts.xsmall};
    color: ${token('color.text.subtlest', colors.N200)};
    font-weight: 500;
`;

export const StyledFakeButton = styled(FakeButton)`
    display: block;
`;
